<mat-spinner [diameter]="50" class="data-loader"></mat-spinner>
